import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { st, FormControl, Form, FormMessage, Button } from "lib/index";
import AuthLayout from "modules/app/AuthLayout";
import { stateSelector, initializeView, updateModel, submit } from "./index";

@connect(
  (state) => ({
    model: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading,
    errors: stateSelector(state).form.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        updateModel,
        submit,
      },
      dispatch
    )
)
// TODO
export default class LoginView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView({ redirectAfterLogin: this.props.location.query.next });
  }

  handleModelPropChange(prop, value) {
    const { model, updateModel } = this.props;
    updateModel({
      ...model,
      [prop]: value,
    });
  }

  handleSubmit(event) {
    const { submit } = this.props;
    event.preventDefault();
    submit();
  }

  render() {
    const { model, submitLoading, valid, errors } = this.props;

    return (
      <AuthLayout>
        {model && (
          <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            {!!errors.base && <FormMessage error={errors.base} />}

            <FormControl.InputFormGroup
              {...FormControl.addProps(`model.email`, { errors })}
              value={model.email}
              onChange={this.handleModelPropChange.bind(this, "email")}
              label={I18n.humanAttributeName("admin_user", "email")}
              type="email"
              required
            />

            <FormControl.InputFormGroup
              {...FormControl.addProps(`model.password`, { errors })}
              value={model.password}
              onChange={this.handleModelPropChange.bind(this, "password")}
              label={I18n.humanAttributeName("admin_user", "password")}
              type="password"
              required
            />

            <Button primary floated="right" type="submit" content="Zaloguj się" />
          </Form>
        )}
      </AuthLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/UnlockAccessView/UnlockAccessView.jsx